import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PlayerContactModel } from '../../../shared/models/player.model';
import { ScoutingPlayerService } from '../../../shared/services/scouting-player.service';
import { UserService } from '../../../shared/services/user.service';
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { MaterialModule } from '../../../material/material.module';




@Component({
    selector: 'app-player-contact-card',
    imports: [MaterialModule],
    templateUrl: './player-contact-card.component.html',
    styleUrls: ['./player-contact-card.component.css']
})
export class PlayerContactCardComponent implements OnInit {

  @Input() Contact: PlayerContactModel;
  @Output() ContactDeleted = new EventEmitter();
  @Output() ContactUpdated = new EventEmitter();

  isAllowedToEdit: boolean = false;

  constructor(private scoutingService: ScoutingPlayerService,public userService: UserService,private dialog: MatDialog) {

    this.isAllowedToEdit = this.userService.roleMatch(["Org_Admin", "Contacts_Editor"]);
  }

  ngOnInit(): void {
    //console.log(this.Contact);
  }

  

  deleteContact(){
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: "Do you want to delete the contact? "
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.scoutingService.deletePlayerContact(this.Contact).subscribe(result=>{
          if(result)
            this.ContactDeleted.emit(this.Contact.ContactId);
        });
      }
    });   
  }

   ediContact(){
   /*
    const dialogRef = this.dialog.open(AddPlayerContactDialogComponent, {
      width: '450px',
      data:  {Contact: this.Contact}
    });
    dialogRef.afterClosed().subscribe(result => {
      
        this.ContactUpdated.emit(this.Contact);
      
    });  */  
  
  }

}
